import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "./config/axios"; // ?
import "./index.css";

// Initiate Axios
axios._initiate();

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
